import { Filter } from "filter";
import EditInvoiceBox from "./EditInvoice";
import { useEffect, useState } from "react";
import { CommonUtilities } from "commonUtils";
import InvoiceUpdateField from "./invoiceUpdateField";
import TransactionServices from "../TransactionServices";
import Pagination from 'components/Common/newPagination';
import InvoiceCheckBox from "../SalesAnalysis/InvoiceCheck";
import InvoiceDetailBox from "../SalesAnalysis/InvoiceDetail";
import DeleteDialogueBox from "components/Common/deleteDialogue";
import cachingMechanisum from "components/Common/cachingMechanisum";
import DatePickerRange from "components/PeriodSelection/DatePickerRange";

export default function Transactions(subEntity: any) {

    let [showtab, setShowTab] = useState(1);
    let [message, setMessage] = useState("");
    let [viewAll, setViewAll] = useState<any>([]);
    let [deleteType, setDeleteType] = useState("");
    let [dateError, setDateError] = useState(false);
    let [periodError, setPeriodError] = useState(false);
    let [deleteData, setDeleteData] = useState<any>([]);
    let [filterByDate, setfilterByDate] = useState(true);
    let [deleteStatus, setDeleteStatus] = useState(false);
    let [viewAllTemp, setViewAllTemp] = useState<any>([]);
    let [periodSelected, setPeriodSelected] = useState("");
    let [paginationCount, setPaginationCount] = useState(0);
    let [quarterlyPeriod, setQuarterlyPeriod] = useState("");
    let [selectInvoice, setSelectInvoice] = useState<any>([]);
    let [invoiceSelect, setInvoiceSelect] = useState<any>([]);
    let [filterInvoiceTbl, setfilterInvoiceTbl] = useState("");
    let [openPeriodList, setopenPeriodList] = useState<any>([]);
    let [chkApprovedInvoices, setchkApprovedInvoices] = useState(2);
    let [editInvoiceStatus, setEditInvoiceStatus] = useState(false);
    let [invoiceCheckStatus, setInvoiceCheckStatus] = useState(false);
    let [invoiceDetailStatus, setInvoiceDetailStatus] = useState(false);
    let [InvoiceUpdateSelect, setInvoiceUpdateSelect] = useState(false);
    let [InvoiceUpdateFieldStatus, setInvoiceUpdateFieldStatus] = useState(false);

    var pagination = { pageNumber: 1, pageSize: 10 }
    var Data: any = { pageSize: 10, pageNumber: 1, totalRows: 0 }

    useEffect(() => {
        /*TransactionServices.periodCount({}).then((respond: any) => {
            setopenPeriodList(respond)

            periodSelected = respond?.filter((e: any) => e.periodCurrent == 1)[0].periodDesc
            setPeriodSelected(periodSelected)
        })*/

        var periodListCache = cachingMechanisum.getCachingStorage("SystemPeriod");
        setopenPeriodList(periodListCache);

        periodSelected = periodListCache?.filter((e: any) => e.periodCurrent == 1)[0].periodDesc
        setPeriodSelected(periodSelected)

    }, []);

    const ViewAll_search = () => {
        var tab_Name = "publishingSong"
        if (showtab == 1) { tab_Name = "publishingSong" }
        if (showtab == 2) { tab_Name = "publishingWriter" }
        if (showtab == 3) { tab_Name = "digital" }
        if (showtab == 4) { tab_Name = "physical" }
        if (showtab == 5) { tab_Name = "costs" }
        if (showtab == 6) { tab_Name = "advances" }
        if (showtab == 7) { tab_Name = "licensing" }
        if (showtab == 8) { tab_Name = "adjustments" }

        TransactionServices.getViewAll({}, tab_Name, "").then((res: any) => {

            viewAll = res?.slice((pagination.pageNumber - 1) * pagination.pageSize, (pagination.pageSize * pagination.pageNumber))
            setViewAll(viewAll)
            viewAllTemp = res
            setViewAllTemp(viewAllTemp)

            paginationCount = res.length;
            setPaginationCount(paginationCount)
            console.log("test for view all button")
        })
    }

    const SearchListing = () => {
        var tab_Name = "publishingSong"
        if (showtab == 1) { tab_Name = "publishingSong" }
        if (showtab == 2) { tab_Name = "publishingWriter" }
        if (showtab == 3) { tab_Name = "digital" }
        if (showtab == 4) { tab_Name = "physical" }
        if (showtab == 5) { tab_Name = "costs" }
        if (showtab == 6) { tab_Name = "advances" }
        if (showtab == 7) { tab_Name = "licensing" }
        if (showtab == 8) { tab_Name = "adjustments" }

        var url = ''
        var payload = { invoiceFrom: Filter?.DateTimeFormatNumberSeparate(periodSelected.toString()), invoiceTo: Filter?.DateTimeFormatNumberSeparate(periodSelected.toString()) }
        console.log(invoiceDateFrom)
        console.log(invoiceDateTo)

        if (!filterByDate) {
            if (chkApprovedInvoices == 2) { url = url + "/true" }

            if (chkApprovedInvoices == 3) { url = url + "/false" }

            if (periodSelected) { url = url + "/" + periodSelected }
        }

        if (filterByDate) {
            payload.invoiceFrom = invoiceDateFrom
            payload.invoiceTo = invoiceDateTo
        }

        TransactionServices.getViewAll(!filterByDate ? {} : payload, tab_Name, url).then((res: any) => {

            viewAll = res?.slice((pagination.pageNumber - 1) * pagination.pageSize, (pagination.pageSize * pagination.pageNumber))
            setViewAll(viewAll)
            viewAllTemp = res
            setViewAllTemp(viewAllTemp)

            paginationCount = res.length;
            setPaginationCount(paginationCount)
            console.log("test for view all button")
        })
    }

    const currentPage = (e: number) => { setShowTab(e); }

    const invoiceCheck = () => {
        setInvoiceCheckStatus(true)
    }

    const InvoiceCheckClose = () => {
        invoiceCheckStatus = false
        setInvoiceCheckStatus(false)
    }

    const invoiceDetail = (e: any) => {
        selectInvoice = e;
        setSelectInvoice(selectInvoice)

        invoiceDetailStatus = true;
        setInvoiceDetailStatus(invoiceDetailStatus)
    }

    const InvoiceDetailClose = () => {
        invoiceDetailStatus = false
        setInvoiceDetailStatus(invoiceDetailStatus)
    }

    const editInvoice = (e: any) => {
        invoiceSelect = e;
        setInvoiceSelect(invoiceSelect)
        editInvoiceStatus = true;
        setEditInvoiceStatus(editInvoiceStatus)
    }

    const EditInvoiceClose = () => {
        editInvoiceStatus = false
        setEditInvoiceStatus(false)
    }

    const deleteSelection = (e: any, data: any) => {
        deleteData = data;
        setDeleteData(deleteData)

        deleteStatus = true;
        setDeleteStatus(deleteStatus)

        deleteType = e
        setDeleteType(deleteType)

        console.log(deleteData)
        if (e == "Approve All Invoice") {
            message = `confirm all invoice(s) for ${deleteData?.headerType} invoice`;
            setMessage(message)
        }

        if (e == "delete invoice") {
            message = `delete invoice ref: ${deleteData?.invoiceNum}`;
            setMessage(message)
        }

        if (e == "reset invoice") {
            message = `reset invoice ref: ${deleteData?.invoiceNum}`;
            setMessage(message)
        }

        if (e == "delete Approve invoice") {
            message = `delete the approved invoice ${deleteData?.invoiceNum}`;
            setMessage(message)
        }

    }

    const invoiceRecycle = () => {

        if (deleteData?.invoiceNum) {
            TransactionServices.recycleInvoice(deleteData?.invoiceNum)
            TransactionServices.delInvoiceFileIng(deleteData?.invoiceNum, deleteData?.headerType)
            const message = `Invoice queued for recycling`;
            CommonUtilities.showToastDawer(message, 'Success')
        }
    }

    const invoiceDelete = () => {
        if (deleteData?.invoiceNum) {
            TransactionServices.deleteInvoice(deleteData)
            TransactionServices.delInvoiceFileIng(deleteData?.invoiceNum, deleteData?.headerType)

            const message = `The invoice account for has been deleted successfully`;
            CommonUtilities.showToastDawer(message, 'Success')
        }
    }

    const approvedDelete = () => {
        if (deleteData?.invoiceNum) {
            TransactionServices.deleteInvoice(deleteData)
            TransactionServices.delInvoiceFileIng(deleteData?.invoiceNum, deleteData?.headerType)

            const message = `The invoice ${deleteData?.invoiceD} has been archived successfully and is currently been deleted.  Please rerun Post Approved.`;
            CommonUtilities.showToastDawer(message, 'Success')
        }
    }

    const approveAll = () => {

        if (deleteData?.invoiceNum) {
            TransactionServices.approveAll(deleteData?.headerType)
        }
    }

    const invoicePostApproved = (period_Selected: any) => {
        TransactionServices.invoicePostApproved(period_Selected, 0).then((res: any) => {
            if (res != null && res.result == true) {
                CommonUtilities.showToastDawer('Operation queued for processing', 'Success')
            } else {
                CommonUtilities.showToastDawer('Re-run this operation after a few mins as similar job already in progress', 'Success')
            }
        })
    }

    const checkPeriodValidation = (invPeriod: any) => {

        var periodValidation = false;

        for (var $i = 0; $i < openPeriodList.length; $i++) {
            if (openPeriodList[$i] == invPeriod) {
                periodValidation = true;
            }
        }

        return periodValidation;
    }

    const deleteConfirmation = (e: any) => {
        console.log(e)

        //e==1 YES
        console.log(deleteData)
        if (e == 1) {

            if (deleteType == "Approve All Invoice") {
                approveAll();
            }

            if (deleteType == "delete invoice") {
                invoiceDelete();
            }

            if (deleteType == "reset invoice") {
                invoiceRecycle();
            }

            if (deleteType == "delete Approve invoice") {
                approvedDelete()
            }
        }
        //e==2 NO
        deleteStatus = false;
        setDeleteStatus(deleteStatus)
    }

    const InvoiceUpdateFieldSelect = (e: any) => {
        InvoiceUpdateSelect = e;
        setInvoiceUpdateSelect(InvoiceUpdateSelect)
        InvoiceUpdateFieldStatus = true;
        setInvoiceUpdateFieldStatus(InvoiceUpdateFieldStatus)
    }

    const InvoiceUpdateFieldClose = (e: any) => {
        InvoiceUpdateFieldStatus = false;
        setInvoiceUpdateFieldStatus(InvoiceUpdateFieldStatus)
    }

    const filter_search = (e: any) => {

        filterInvoiceTbl = e;
        setfilterInvoiceTbl(filterInvoiceTbl)
        var FE_search = viewAllTemp?.filter((e: any) => {
            const search = filterInvoiceTbl?.toLowerCase() || '';

            return (
                e?.transactionRef?.toLowerCase()?.includes(search) ||
                e?.invoiceNum?.toLowerCase()?.includes(search) ||
                e?.accountCode?.toLowerCase()?.includes(search)
            );
        })

        paginationCount = FE_search.length;
        setPaginationCount(paginationCount)
        FE_search = FE_search?.slice((pagination.pageNumber - 1) * pagination.pageSize, (pagination.pageSize * pagination.pageNumber))
        setViewAll(FE_search)
    }

    const handleNameOnChange = (paginationEvent: any) => {
        pagination.pageNumber = paginationEvent.pageNumber;
        pagination.pageSize = paginationEvent.pageSize;

        filter_search(filterInvoiceTbl);
    }

    let [invoiceDateTo, setInvoiceDateTo] = useState("");
    let [invoiceDateFrom, setInvoiceDateFrom] = useState("");
    const dateSelectionFrom = (e: any) => {
        console.log(e)
        let invoice_Date = Filter?.DateTimeFormatNumberSeparate(e) ?? "";
        console.log(invoice_Date)
        console.log(typeof invoice_Date)
        invoiceDateFrom = typeof invoice_Date == "string" ? invoice_Date : "";
        setInvoiceDateFrom(invoiceDateFrom)
    }

    const dateSelectionTo = (e: any) => {
        console.log(e)
        let invoice_Date = Filter?.DateTimeFormatNumberSeparate(e) ?? "";
        invoiceDateTo = typeof invoice_Date == "string" ? invoice_Date : "";
        setInvoiceDateTo(invoiceDateTo)
    }

    const exportInvoices = (event: any) => {

        var payload = {
            approvalStatus: chkApprovedInvoices == 3 ? false : chkApprovedInvoices == 2 ? true : null,
            royaltyPeriod: periodSelected,
            exp: "",
            header: ""
        }

        if (event) {
            payload.exp = "both"
            payload.header = ""
        }

        if (!event) {
            var tab_Name = ""
            if (showtab == 1) { tab_Name = "publishingSong" }
            if (showtab == 2) { tab_Name = "publishingWriter" }
            if (showtab == 3) { tab_Name = "digital" }
            if (showtab == 4) { tab_Name = "physical" }
            if (showtab == 5) { tab_Name = "costs" }
            if (showtab == 6) { tab_Name = "advances" }
            if (showtab == 7) { tab_Name = "licensing" }
            if (showtab == 8) { tab_Name = "adjustments" }

            payload.exp = ""
            payload.header = tab_Name

        }

        TransactionServices.salesAnalysisExport(payload)
    }

    const invoiceApprove = (invoice: any) => {
        var tempInvoice = {
            "invId": invoice.invId,
            "accountCode": invoice.accountCode,
            "invoiceNum": invoice.invoiceNum,
            "invoiceDate": invoice.invoiceDate,
            "currencyValue": invoice.currencyValue,
            "exchRate1": invoice.exchRate1,
            "homeValue": invoice.homeValue,
            "currencySign": invoice.currencySign,
            "invDescription": invoice.invDescription,
            "setRelease": invoice.setRelease,
            "royaltyPeriod": invoice.royaltyPeriod,
            "isApproved": invoice.isApproved,
            "approvalStatus": invoice.approvalStatus,
            "transactionRef": invoice.transactionRef,
            "comments": invoice.comments,
            "hasData": invoice.hasData,
            'headerType': invoice.headerType,
            "homeSign": invoice.homeSign
        }

        console.log(tempInvoice)

        var confirm = window.confirm('Do you want to approve this invoice?');
        if (!confirm) {
            return;
        }
        TransactionServices.invoice_save(tempInvoice)
    };

    return (
        <>
            <div className="ws-12 box borderRounded">
                <ul className="nav nav-tabs nav-justified pLarge">

                    <a id="1" className={showtab === 1 ? "icon-btn edit fill" : "icon-btn edit"} onClick={() => currentPage(1)}>Publishing - Song</a>
                    <a id="2" className={showtab === 2 ? "icon-btn edit fill" : "icon-btn edit"} onClick={() => currentPage(2)}>Publishing - Writer</a>
                    <a id="3" className={showtab === 3 ? "icon-btn edit fill" : "icon-btn edit"} onClick={() => currentPage(3)}>Digital</a>
                    <a id="4" className={showtab === 4 ? "icon-btn edit fill" : "icon-btn edit"} onClick={() => currentPage(4)}>Physical</a>
                    <a id="5" className={showtab === 5 ? "icon-btn edit fill" : "icon-btn edit"} onClick={() => currentPage(5)}>Cost</a>
                    <a id="6" className={showtab === 6 ? "icon-btn edit fill" : "icon-btn edit"} onClick={() => currentPage(6)}>Advances</a>
                    <a id="7" className={showtab === 7 ? "icon-btn edit fill" : "icon-btn edit"} onClick={() => currentPage(7)}>Licensing</a>
                    <a id="8" className={showtab === 8 ? "icon-btn edit fill" : "icon-btn edit"} onClick={() => currentPage(8)}>Adjustments</a>
                </ul>

                <div className="ws-12 box borderRounded mb">

                    <div className="box-header well">
                        <h2>
                            {
                                showtab === 1 ? "Publishing Song" : showtab === 2 ? "Publishing Writer" : showtab === 3 ? "Digital" :
                                    showtab === 4 ? "Physical" : showtab === 5 ? "Costs" : showtab === 6 ? "Advances" : showtab === 7 ? "Licensing" :
                                        showtab === 8 ? "Adjustments" : ""
                            } Transaction Listing
                        </h2>
                    </div>

                    <div className="box-content">

                        {dateError && <div className="alert alert-info">Please select a Date From and a Date To</div>}
                        {periodError && <div className="alert alert-info">Please select a period first</div>}

                        <div className="ws-12">

                            <span className="pull-left mrl ws-2 text-bold">Filter transactions by </span>

                            <div className="ws-6 mbl">

                                <div className="input-group">
                                    <label className="pull-left mrl ">
                                        <input type="radio" name="filterByDate" checked={filterByDate} onClick={() => { filterByDate = !filterByDate; setfilterByDate(filterByDate) }} /> date
                                    </label>
                                    <label className="pull-left mrl ">
                                        <input type="radio" name="filterByDate" checked={!filterByDate} onClick={() => { filterByDate = !filterByDate; setfilterByDate(filterByDate) }} /> approval status
                                    </label>
                                </div>
                            </div>

                        </div>

                        {filterByDate && <div className="ws-12">
                            <div className="ws-3 ps">
                                <span className="text-bold pr ws-12"><i className="fa fa-calendar"></i> Date From</span>
                                <input type="text" className="ws-12 hide" placeholder="Select a Date" readOnly />
                                <DatePickerRange onChange={dateSelectionFrom} name={""} type={"single"} data={invoiceDateFrom ?? ""} id="invoiceDate" />
                            </div>

                            <div className="ws-3 ps">
                                <span className="text-bold pr ws-12" title="Leave blank to set same as Date From"><i className="fa fa-calendar"></i> Date To</span>
                                <input type="text" className="ws-12 hide" placeholder="Select a Date" ng-model="invoiceDateTo" readOnly />
                                <DatePickerRange onChange={dateSelectionTo} name={""} type={"single"} data={invoiceDateTo ?? ""} id="invoiceDate" />
                            </div>

                        </div>}

                        {!filterByDate && <div className="ws-12 mbl">
                            <div className="ws-6">
                                <label className="pull-left mrl ">
                                    <input type="radio" checked={chkApprovedInvoices == 1} onClick={() => setchkApprovedInvoices(1)} name="694" /> All
                                </label>
                                <label className="pull-left mrl ">
                                    <input type="radio" checked={chkApprovedInvoices == 2} onClick={() => setchkApprovedInvoices(2)} name="695" /> Approved
                                </label>
                                <label className="pull-left mrl ">
                                    <input type="radio" checked={chkApprovedInvoices == 3} onClick={() => setchkApprovedInvoices(3)} name="696" /> Un-Approved
                                </label>
                            </div>
                            <div className="ws-6">
                                <div className="input-group">
                                    <span className="input-group-addon mr"><i className="fa fa-calendar"></i> Period</span>
                                    <select className="optionSpacer " onChange={(e: any) => { periodSelected = e.target.value; setPeriodSelected(periodSelected) }} value={periodSelected}>
                                        {
                                            openPeriodList?.map((values: any) => {
                                                return (

                                                    <option value={values?.periodDesc} label={Filter?.SimplemonthAndDayYear(values?.periodFrom) + " - " + Filter?.SimplemonthAndDayYear(values?.periodTo)} className={values?.periodOpen == 2 ? 'text-bold purple' : 'text-bold success'} >

                                                    </option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>
                            </div>

                        </div>}

                        <div className="mtxl ws-12">
                            <a className="icon-btn edit pull-left " onClick={() => editInvoice({})}>New Transaction</a>
                            <a className="icon-btn primary pull-right " onClick={invoiceCheck}>Invoice Check</a>
                            <a className="icon-btn edit pull-right " onClick={ViewAll_search}>View All</a>
                            <a className="icon-btn edit pull-right" title="Search" onClick={SearchListing}><i className="icon-search"></i> Search</a>
                        </div>

                    </div>
                </div>

                <div className="ws-12 box borderRounded">
                    <div className="box-header well"> <h2>Search result for  - {paginationCount} record(s) found</h2>  </div>

                    <div className="box-content">
                        {false && <div className="alert alert-info">The invoice account for has been deleted successfully</div>}
                        {false && <div className="alert alert-info">The invoice has been archieved successfuly and is currently been deleted Please return Post Approved.</div>}
                        {false && <div className="alert alert-info">Operation queued for processing</div>}
                        {false && <div className="alert alert-info">Re-run this operation after a few mins as similar job already in progress</div>}
                        {false && <div className="alert alert-info">Invoice queued for recycling</div>}

                        {(paginationCount == 0) && <div className="alert alert-info">No records found</div>}

                        {(paginationCount > 0) && <div className="ws-12">

                            <div className="ws-12">
                                <div className="form-format ws-6">
                                    <label className="control-label ">Filter invoices</label>
                                    <div className="label-entries">
                                        <input id="filterInvoiceTbl" type="text" className="input-sm " onChange={(e: any) => filter_search(e.target.value)} placeholder="Search" />
                                    </div>
                                </div>

                                <a className="btn icon-btn warning pull-right mb fill mtxl" onClick={() => deleteSelection("Approve All Invoice", {})}><i className="icon-tick"></i> Approve All Invoice(s) </a>
                            </div>

                            {(paginationCount > 0) && <table className="NewTable">
                                <thead>
                                    <tr>
                                        <th className="forceSingleLine">Account</th>
                                        <th className="forceSingleLine">Invoice</th>
                                        <th className="forceSingleLine">Transaction Ref</th>
                                        <th className="forceSingleLine">Home Value</th>
                                        <th className="forceSingleLine">Currency</th>
                                        <th className="forceSingleLine">Curr Value</th>
                                        <th className="forceSingleLine">Exch Rate</th>
                                        <th className="forceSingleLine">Royalty Period</th>
                                        <th className="forceSingleLine">Invoice Date</th>
                                        <th className="forceSingleLine">Approve</th>
                                        <th>Operation</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {viewAll?.map((values: any) => {
                                        return (
                                            <tr>
                                                <td>{values.accountCode}</td>
                                                <td>{values.invoiceNum}</td>
                                                <td>{values.transactionRef}</td>
                                                <td>{values.homeValue.toFixed(2)}</td>
                                                <td>{values.currencySign}</td>
                                                <td>{values.currencyValue.toFixed(2)}</td>
                                                <td>{values.exchRate1.toFixed(2)}</td>
                                                <td>{Filter.NumToDate(values.royaltyPeriod)}</td>
                                                <td>{Filter.DateMonthYear(values.invoiceDate)}</td>
                                                <td>
                                                    {values.approvalStatus && values.isApproved && <span className="label label-success">Approved</span>}
                                                    {(values.approvalStatus != true && values.isApproved == true) &&
                                                        <a title="Approve this invoice. After approval no modifications can be made to this invoice." className="btn btn-xs icon-btn edit" onClick={() => invoiceApprove(values)}>
                                                            <i className="icon-tick"></i>
                                                        </a>}
                                                </td>
                                                <td>
                                                    <div className="width225">

                                                        {values.hasData == 1 && <a title="Update Field" className="btn btn-xs icon-btn edit" onClick={() => InvoiceUpdateFieldSelect(values)}>
                                                            <i className="icon-checkmark1"></i>
                                                        </a>}

                                                        {!values.approvalStatus && <a title="Edit" className="btn btn-xs icon-btn edit" onClick={() => editInvoice(values)} >
                                                            <i className="icon-edit-pencil"></i>
                                                        </a>}

                                                        <a title="Detail" className="btn btn-xs icon-btn primary" onClick={() => invoiceDetail(values)}>
                                                            <i className="icon-file3"></i>
                                                        </a>

                                                        {!(values.approvalStatus || values.hasData != 1) && <a title="Recycle" className="btn btn-xs icon-btn warning fill" onClick={() => { deleteSelection("reset invoice", values); }}>
                                                            <i className="icon-refresh"></i>
                                                        </a>}


                                                        {!values.approvalStatus && <a title="Delete" className="btn-xs btn-small icon-btn delete" onClick={() => { deleteSelection("delete invoice", values) }}>
                                                            <i className="icon-trash"></i>
                                                        </a>}

                                                        {values.approvalStatus && values.isApproved && checkPeriodValidation(values.royaltyPeriod) && <a title="Remove" className="btn-xs btn-small icon-btn delete" onClick={() => { deleteSelection("delete Approve invoice", values) }}>
                                                            <i className="icon-trash"></i>
                                                        </a>}

                                                        <a className="btn icon-btn edit btn-xs hide" title="Commit" ><i className="icon-tick"></i></a>
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    })}
                                </tbody>

                                <tfoot>
                                    <tr>
                                        <td colSpan={10}>
                                            <div className="row-fluid form-condensed mt">
                                                <div className="ws-2">
                                                    <a className="icon-btn warning fill pull-right" onClick={() => invoicePostApproved(quarterlyPeriod)}><i className="icon-tick"></i>  Post Approved</a>
                                                </div>
                                                <div className="span4">
                                                    <div className="input-group">
                                                        <span className="input-group-addon">Approved Period</span>
                                                        <select onChange={(e: any) => { quarterlyPeriod = e.target.value; setQuarterlyPeriod(quarterlyPeriod) }} value={quarterlyPeriod}>
                                                            {
                                                                openPeriodList?.map((values: any) => {
                                                                    return (

                                                                        <option value={values?.periodDesc} label={Filter?.SimplemonthAndDayYear(values?.periodFrom) + " - " + Filter?.SimplemonthAndDayYear(values?.periodTo)} className={values?.periodOpen == 2 ? 'text-bold purple' : 'text-bold success'} >

                                                                        </option>
                                                                    )
                                                                })
                                                            }
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tfoot>

                            </table>}

                            <div className="clearfix overflowVisible">

                                <div className="hover-box verticalMediumWide mts pull-left overflowVisible" >
                                    <i className="fa icon-files-text"></i>
                                    <button className="icon-btn edit mtll mbl" onClick={() => exportInvoices(true)}>Export</button>
                                    <div className="hover-block width190 borderRounded">
                                        <a className="hover-box icon-btn edit width80 mt" onClick={() => exportInvoices(false)}>Digital</a>
                                        <a className="hover-box icon-btn edit width80 mt" onClick={() => exportInvoices(true)}>All</a>
                                    </div>
                                </div>

                                <div className="ws-10">
                                    {(() => {
                                        if (paginationCount && paginationCount > 10) {
                                            return <Pagination onPageChange={handleNameOnChange} totalRow={paginationCount} />
                                        }
                                    })()}

                                </div>
                            </div>

                        </div>}
                    </div>
                </div>
            </div>

            {
                (() => {
                    if (invoiceCheckStatus) {
                        return <InvoiceCheckBox param={invoiceCheckStatus} InvoiceCheckClose={InvoiceCheckClose} headerType={showtab} />
                    }

                    if (invoiceDetailStatus) {
                        return <InvoiceDetailBox param={invoiceDetailStatus} InvoiceDetailClose={InvoiceDetailClose} selectInvoice={selectInvoice} />
                    }

                    if (editInvoiceStatus) {
                        return <EditInvoiceBox param={editInvoiceStatus} EditInvoiceClose={EditInvoiceClose} invoiceSelect={invoiceSelect} showtab={showtab} />
                    }

                    if (deleteStatus) {
                        return <DeleteDialogueBox param={deleteStatus} message={message} onChange={deleteConfirmation} />
                    }

                    if (InvoiceUpdateFieldStatus) {
                        return <InvoiceUpdateField InvoiceUpdateFieldStatus={InvoiceUpdateFieldStatus} InvoiceUpdateFieldClose={InvoiceUpdateFieldClose} InvoiceUpdateSelect={InvoiceUpdateSelect} />
                    }
                })()
            }
        </>
    );
}